import * as React from 'react'
import { FC, useCallback } from 'react'
import { Theme } from '@mui/material/styles'

import { CalendarDatePicker } from '@user/components/CalendarButton'
import {
  useUpdateOpportunityExpectedClosingDate,
  useUpdateOpportunityNextActionDate,
} from '@user/store/opportunity'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { ENTITY_TYPES } from '@sales-center/common'
import { useCheckPermissions } from '@user/store/authorization/permissions/useCheckPermissions'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'

const styles = {
  root: {
    marginBottom: (theme: Theme) => theme.spacing(1),
  },

  expectedClosingDateLabel: {
    fontFamily: 'Source Sans Pro Semibold',
  },
}

interface Props {
  disabled: boolean
  expectedClosingDate: Date | null
  required?: boolean
  id: number
}

export const ExpectedClosingDate: FC<Props> = (props) => {
  const { disabled, expectedClosingDate, id, required } = props

  const { execute: updateOpportunityExpectedClosingDate } =
    useUpdateOpportunityExpectedClosingDate()
  const { execute: updateOpportunityNextActionDate } =
    useUpdateOpportunityNextActionDate()

  const handleExpectedClosingDateChange = useCallback(
    (date: Date | null) => {
      if (date !== null)
        updateOpportunityExpectedClosingDate({
          opportunityId: id,
          expectedClosingDate: date,
        })
    },
    [id, updateOpportunityExpectedClosingDate],
  )

  const [canUpdateOpps] = useCheckPermissions('opportunities_update')
  const { getFormat } = useLocalizationDateFormat()
  return (
    <Box>
      <Typography sx={styles.expectedClosingDateLabel} component="div">
        Expected Closing Date
      </Typography>
      <CalendarDatePicker
        canUpdate={canUpdateOpps}
        clearable={!required}
        disabled={disabled}
        value={expectedClosingDate}
        disablePast={false}
        onAccept={handleExpectedClosingDateChange}
        datePickerType="expectedclosing"
        entityType={ENTITY_TYPES.Opportunity}
        id={id}
        updateOtherDateCallback={updateOpportunityNextActionDate}
        format={getFormat()}
        dataTestId={`expecting-closing-date-${id}`}
      />
    </Box>
  )
}

ExpectedClosingDate.displayName = 'ExpectedClosingDate'
